import { fluid } from '@helpers/fluid';
import { Device } from '@helpers/media';
import * as React from 'react';
import { getSystemLogoHeight, renderSystemLogo } from '../../Header.systems';
import { NavigationItemModel } from '../../Header.types';
import DesktopNavigationDropdownLink from '../DesktopNavigationDropdownLink/DesktopNavigationDropdownLink';
import S from './SystemDropdown.styles';

export type SystemDropdownProps = {
  sectionTitle?: string;
  items: NavigationItemModel[];
  translations: Record<string, string>;
};

const SystemDropdown: React.FC<SystemDropdownProps> = ({ sectionTitle, items, translations }) => {
  return (
    <S.Container>
      {sectionTitle && <S.SectionTitle dangerouslySetInnerHTML={{ __html: sectionTitle }} />}
      {items &&
        items.map((item) => (
          <S.Column key={item.id} style={{ '--columnWidth': `${100 / items.length}%` } as React.CSSProperties}>
            <li>
              <S.SystemLogo
                style={
                  {
                    '--systemLogoHeight': `${fluid(
                      getSystemLogoHeight(item.systemLogo) * 0.7,
                      getSystemLogoHeight(item.systemLogo),
                      Device.DesktopSmall,
                      Device.ActualDesktop,
                    )}`,
                  } as React.CSSProperties
                }
              >
                {renderSystemLogo(item.systemLogo)}
              </S.SystemLogo>
            </li>
            {item.title && (
              <li>
                <S.Title>{item.title}</S.Title>
              </li>
            )}
            {item.children &&
              item.children.map((child) => (
                <DesktopNavigationDropdownLink
                  key={child.id}
                  item={child}
                  dropdownLevel="2"
                  translations={translations}
                />
              ))}
          </S.Column>
        ))}
    </S.Container>
  );
};

export default SystemDropdown;
